module.exports = __webpack_public_path__ + "img/skimmer_stopped.a4a3d6d1.svg";